import { ENV } from '../config/env'
import {
  findEmbedScript,
  resolveSiteKey,
  siteKeyFromScriptSrc
} from './siteKey'

const container = document.getElementById('adlSearchboxContainer')

export function getMaxNumberOfAdults(): number {
  return Number(container?.getAttribute('max-guests') ?? 20)
}

export function getSiteKeyFromURL() {
  const urlParams = new URLSearchParams(window.location.search)
  const myParam = urlParams.get('site-key')
  return myParam || ''
}

export function getInitialReferer() {
  const urlParams = new URLSearchParams(window.location.search)
  const myParam = urlParams.get('initial-referer')
  if (!myParam) {
    const initialRef = localStorage.getItem('initial-referer')
    return initialRef
  } else {
    localStorage.setItem('initial-referer', myParam || '')
    return myParam
  }
}

const searchBoxScript = findEmbedScript(document)

const src = searchBoxScript?.getAttribute('src') || ''
const scriptKey = siteKeyFromScriptSrc(src, window.location.href)

if (scriptKey) {
  localStorage.setItem('site-key', scriptKey)
}

if (getSiteKeyFromURL()) {
  localStorage.setItem('site-key', getSiteKeyFromURL())
}

export const SITE_KEY = resolveSiteKey({
  scriptKey,
  urlKey: getSiteKeyFromURL(),
  defaultKey: ENV.WBS_SITE_KEY,
  storedKey: localStorage.getItem('site-key') || localStorage.getItem('SiteKey')
})

const generateRefererKey = () => {
  const length = 16
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const REFERER_KEY = generateRefererKey()

export const customPersianFont = container?.getAttribute('persian-font-family')
export const customEnglishFont = container?.getAttribute('english-font-family')

export const contactPageURL = container?.getAttribute('contact-page')
